import { render } from "./AyudaGeneracionPlanilla.vue?vue&type=template&id=3a16f4aa&scoped=true"
import script from "./AyudaGeneracionPlanilla.vue?vue&type=script&lang=js"
export * from "./AyudaGeneracionPlanilla.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=3a16f4aa&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a16f4aa"]])

export default __exports__